/* SERUM · Aufklappfeld in der Kopfzeile (snippets/header-mega-menu.liquid, .serum-dd)
   Öffnet erst, wenn die Maus sich auf dem Menüpunkt bewegt und kurz verweilt. Wer nur vorbeifährt
   (z. B. zu „Zurück zum Guide") oder unter dessen Zeiger die Kopfzeile erscheint, löst nichts aus.
   Tastatur: Fokus öffnet, Escape schließt. Ein Klick auf den Menüpunkt führt zur Kollektion. */
(function () {
  document.querySelectorAll('[data-serum-dd]').forEach(function (dd) {
    var trigger = dd.querySelector('.serum-dd__trigger');
    var openT = null;
    var closeT = null;

    function open() {
      dd.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      dd.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    dd.addEventListener('mousemove', function () {
      clearTimeout(closeT);
      if (dd.classList.contains('is-open') || openT) return;
      openT = setTimeout(function () { openT = null; open(); }, 220);
    });
    dd.addEventListener('mouseleave', function () {
      clearTimeout(openT);
      openT = null;
      closeT = setTimeout(close, 150);
    });
    dd.addEventListener('focusin', function (ev) {
      if (ev.target.matches(':focus-visible')) open();
    });
    dd.addEventListener('focusout', function (ev) {
      if (!dd.contains(ev.relatedTarget)) close();
    });
    dd.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') {
        close();
        if (trigger) trigger.focus({ preventScroll: true });
      }
    });
  });
})();
